import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/authContext'
import type { Role } from '../auth/auth.types'
import type { Permission } from '../auth/accessControl'

interface Props {
  children: JSX.Element
  roles?: Role[] | Role
  permission?: Permission | Permission[]
}

const ProtectedRoute: React.FC<Props> = ({ children, roles, permission }) => {
  const { user, loading, hasRole, can } = useAuth()
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>
  if (!user) return <Navigate to="/login" replace />
  if (permission && !can(permission)) return <div className="p-8">You do not have permission to view this page.</div>
  if (roles) {
    if (!hasRole(roles)) return <div className="p-8">You do not have permission to view this page.</div>
  }
  return children
}

export default ProtectedRoute
